/**
 * Role Intelligence KPI Mock Data
 * Contains dummy data for Role Intelligence KPI metrics in the Details page
 * This data will be replaced with real API responses when backend is ready
 */

const ROLE_INTELLIGENCE_KPI_MOCK_DATA = [
  {
    value: '847',
    label: 'Total Active Roles',
  },
  {
    value: '8',
    label: 'Optimizable Roles',
  },
  {
    value: '5',
    label: 'Tolerance Breaches',
  },
  {
    value: '47',
    label: 'Unused Roles (94 FUE)',
  },
  {
    value: '89',
    label: 'Redundant Auth Objects (156 FUE)',
  },
];

export default ROLE_INTELLIGENCE_KPI_MOCK_DATA;
